import React from 'react';
import { StyleSheet } from './base_components';

import ProgressSpinner from './progress_spinner';
import Select from './select';

import UserAdminStore from '../stores/user_admin_store';

const styles = StyleSheet.create({
  userSelect: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: 'var(--input-text-color)',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: 'var(--input-border-color)',
    backgroundColor: 'var(--input-bg-color)',
  },
  spinner: {
    margin: '1rem',
    width: '2rem',
    height: '2rem',
  },
});

type Props = {
  style?: any;
  orgId: number;
  excludeList?: any;
  value: any;
  onChange: any;
};
export default function UserSelect(props: Props) {
  const { style, excludeList, value, onChange, orgId, ...other } = props;
  const list = UserAdminStore.useList(orgId);
  React.useEffect(() => {
    UserAdminStore.fetch(orgId);
  }, [orgId]);

  function _onChange(new_value) {
    onChange(parseInt(new_value));
  }

  let content: any = null;
  if (!list) {
    content = <ProgressSpinner />;
  } else {
    const valid_list = list.filter((user) => {
      const { user_id } = user;
      let ret = true;
      const excluded = excludeList?.find?.((v) => v.user_id === user_id);
      if (excluded) {
        ret = false;
      }
      return ret;
    });

    const options = [
      ...valid_list.map((u) => ({
        value: u.user_id,
        text: u.user_name ?? u.email,
      })),
    ];

    content = (
      <Select
        style={[styles.userSelect, style]}
        options={options}
        value={value}
        onChange={_onChange}
        {...other}
      />
    );
  }
  return content;
}
